import { buildDrupalImage } from '../Image';

export function mapParagraphAnimatedNumberRange(
  input: AnimatedNumberRangeFragment,
) {
  return {
    key: 'AnimatedNumberElement',
    input: {
      Image: input.Image ? buildDrupalImage(input.Image, 'teaser') : undefined,
      itemTitle: input.itemTitle || '',
      connectingWords: input.itemConnectingWord || '',
      numbers: [
        {
          number: input.itemFirstNumber || '',
          unit: input.itemUnit || '',
          useThousandsSeparator: !input.itemDisableSeparator,
        },
        {
          number: input.itemSecondNumber || '',
          unit: input.itemUnit || '',
          useThousandsSeparator: !input.itemDisableSeparator,
        },
      ],
    },
  };
}
